import React from "react";

const KundliNew = () => {
  return (
    <div className="w-100 h-auto">
      <iframe
        src="https://conceptkundli.framer.website/concept-kundali"
        height={"1000px"}
        width={"100%"}
        style={{ border: "none" }}
        title="Concept Kundli"
      ></iframe>
    </div>
  );
};
export default KundliNew;
